import HomePage from './components/Home/HomePage';
import styles from './App.module.css';

function App() {

  return (
    <div className={styles.app}>
      {/* We pass the redirect function to the existing onNavigateLogin prop 
        so you don't have to change code inside HomePage.jsx 
      */}
      <HomePage />
    </div>
  );
}

export default App;